var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShotOffTarget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polyline", {
    points: "12.79 15.61 12.79 4.59 37.21 4.59 37.21 15.61",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.26,
    y1: 15.61,
    x2: 48.74,
    y2: 15.61,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "7.62 15.61 5.75 21.92 25.34 21.92",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "43.05 15.61 44.93 21.92 25.34 21.92",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.7,
    cy: 9.12,
    r: 1.85,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.38,35.31a55.81,55.81,0,0,0,10-12.77,55.21,55.21,0,0,0,4.34-9.7",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.25,42.82,10.11,37,8.46,36A1.15,1.15,0,0,0,6.7,37l.56,5.91a1,1,0,0,0,1.06.89L29,41.89A2,2,0,0,0,29.43,38L16.07,33.66a5.73,5.73,0,0,1-3.65,3.22,5,5,0,0,1-2.59-.05",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.75,
    y1: 36.34,
    x2: 23.24,
    y2: 42.43,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.94,
    y1: 36.89,
    x2: 25.31,
    y2: 38.69,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.46,
    y1: 36.17,
    x2: 22.83,
    y2: 37.97,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.1,
    y1: 35.32,
    x2: 20.47,
    y2: 37.12,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.7,
    y1: 34.55,
    x2: 18.07,
    y2: 36.34,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.74,
    y1: 43.63,
    x2: 28.58,
    y2: 41.93,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.05,
    y1: 43.97,
    x2: 24.89,
    y2: 42.28,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.36,
    y1: 44.32,
    x2: 21.2,
    y2: 42.62,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.39,
    y1: 45.07,
    x2: 13.23,
    y2: 43.37,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.7,
    y1: 45.41,
    x2: 9.54,
    y2: 43.71,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 35.7,
    x2: 4.92,
    y2: 29.02,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.49,
    y1: 34.08,
    x2: 10.93,
    y2: 25.92,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShotOffTarget);
export default __webpack_public_path__ + "static/media/SHOT_OFF_TARGET.18b9cc5c660ba58a36b0bb9e3fe58f76.svg";
export { ForwardRef as ReactComponent };